var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "white",
    stroke: "#5BA0E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5489 32V22.8777H26.6096L27.0688 19.3216H23.5489V17.0515C23.5489 16.0222 23.8335 15.3208 25.3112 15.3208L27.1927 15.32V12.1392C26.8673 12.0969 25.7504 12 24.4504 12C21.7358 12 19.8773 13.657 19.8773 16.6993V19.3216H16.8073V22.8777H19.8773V32H23.5489Z",
    fill: "#5BA0E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.99f752c6a10c8ae16cef9f05b57ee941.svg";
export { ForwardRef as ReactComponent };